// src/components/menu/TopMenu.tsx

import { Fragment, useContext, useEffect, useMemo, useState } from "react";
import { Dropdown } from "flowbite-react"; // Checkbox foi removido dos imports
import { useNavigate } from "react-router-dom";
import { useCompanyAccessStore } from "../../../states/store/CompanyAccess";
import {
  useCompanyStore,
  useCompanyStoreActions,
} from "../../../states/store/Company";
import MenuHamburguer from "./side-menu/MenuHamburguer";
import { BsBuildingDown, BsBuildingsFill } from "react-icons/bs";
import { GrDocumentConfig } from "react-icons/gr";
import { HiBellAlert } from "react-icons/hi2";
import "./TopMenu.scss";
import { IObjectCompanies } from "../../../../types/companyaccess.type";
import { useUser } from "../../../services/users.api";
import { AuthContext } from "../../auth/authContext/AuthContext";

function TopMenu() {
  const navigate = useNavigate();
  const { auth, logout } = useContext(AuthContext);
  const { companyAccess } = useCompanyAccessStore();
  const { selectedCompanies, selectedUf, filterMode } = useCompanyStore();
  const { toggleCompanySelection, setUfSelection, setAllSelection } =
    useCompanyStoreActions();

  const [hasNotification] = useState(false);
  const [roles, setRoles] = useState<string[]>([]);
  const [viewProducts, setViewProducts] = useState(false);
  const user = useUser();

  const totalVehicles = useMemo(() => {
    return (
      companyAccess?.companies?.reduce(
        (sum, company) => sum + (company.statistics?.totalVehicles || 0),
        0
      ) ?? 0
    );
  }, [companyAccess]);

  useEffect(() => {
    if (!auth?.user?.roles) return;
    if (auth.user.roles.length > 0) {
      setRoles(auth.user.roles);
      if (
        auth.user.roles.includes("admin") ||
        auth.user.roles.includes("stockist")
      ) {
        setViewProducts(true);
      }
    }
  }, [auth?.user?.roles]);

  const companyAccessByUF = useMemo(() => {
    const grouped: Record<
      string,
      { total: number; cidades: IObjectCompanies[] }
    > = {};
    if (Array.isArray(companyAccess?.companies)) {
      companyAccess.companies.forEach((item) => {
        const cityParts = item.companyName?.split("/") ?? [];
        const uf = cityParts[1]?.toUpperCase() ?? "SEM_UF";
        const total = item?.statistics?.totalVehicles ?? 0;

        if (!grouped[uf]) {
          grouped[uf] = { total: 0, cidades: [] };
        }
        grouped[uf].cidades.push(item);
        grouped[uf].total += total;
      });
    }
    return grouped;
  }, [companyAccess]);

  const getLocationLabel = () => {
    if (filterMode === "all") {
      return "TODAS AS CIDADES";
    }
    if (filterMode === "uf" && selectedUf) {
      return `TODAS DE ${selectedUf}`;
    }
    if (filterMode === "cities") {
      if (selectedCompanies.length === 1) {
        return selectedCompanies[0].city || "Cidade Selecionada";
      }
      return `MÚLTIPLAS CIDADES (${selectedCompanies.length})`;
    }
    return "Selecione a empresa";
  };

  const isCompanySelected = (companyId: string) => {
    return (
      filterMode === "cities" &&
      selectedCompanies.some((c) => c.companyId === companyId)
    );
  };

  return (
    <header className="top-menu">
      <nav>
        <div className="linha-superior"></div>
        <div className="espacamento"></div>
        <div className="menuhamburguer">
          <MenuHamburguer />
        </div>
        <div className="logo-name">
          <img
            onClick={() => navigate("/")}
            alt="Locavibe logo"
            className="logo-img"
            src="/escudo_vermelho.png"
          />
          <div className="locavibe-backoffice" onClick={() => navigate("/")}>
            <div className="flex justify-center">
              <h2 className="loca ">loca</h2>
              <h2 className="vibe">vibe</h2>
              <h2 className="backoffice">backoffice</h2>
            </div>
          </div>
        </div>
        <div className="flex justify-end">
          {viewProducts && (
            <div className="bell-alert">
              <div className="relative group text-center flex">
                <HiBellAlert
                  className={`text-[25px] ${
                    hasNotification
                      ? "text-redPrimary animate-pulse"
                      : "text-white"
                  }`}
                />
                {hasNotification && (
                  <div className="bellAlert-message group-hover:block">
                    Alerta! Peças no estoque abaixo da quantidade mínima!
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="menu-company-names">
            <Dropdown
              className="dropdown-user-info"
              inline
              label={
                <div>
                  <div className="menu-dropdown">{getLocationLabel()}</div>
                  <div className="menu-dropdown-icon">
                    <BsBuildingDown />
                  </div>
                </div>
              }
            >
              {(roles.some((role) => role === "admin") ||
                companyAccess?.viewAll === true) && (
                <Dropdown.Item
                  key="todas-empresas"
                  className="px-1 py-0"
                  onClick={setAllSelection}
                >
                  <div
                    className={`menu-company-list ${
                      filterMode === "all" ? "selected-company" : ""
                    }`}
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div className="flex items-center gap-2">
                      <BsBuildingsFill />
                      <span>TODAS</span>
                    </div>
                    <span>
                      (
                      {new Intl.NumberFormat("pt-BR").format(
                        typeof totalVehicles === "number" ? totalVehicles : 0
                      )}
                      )
                    </span>
                  </div>
                </Dropdown.Item>
              )}
              <div className="dropdown-scroll-container">
                {Object.entries(companyAccessByUF).map(
                  ([uf, { total, cidades }]) => (
                    <Fragment key={uf}>
                      <Dropdown.Header
                        className={"px-1 py-0 header-company-uf"}
                        onClick={() => setUfSelection(uf)}
                      >
                        <div
                          className={`menu-company-uf ${
                            selectedUf === uf ? "selected-company" : ""
                          }`}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>{uf}</span>
                          <span>
                            ({new Intl.NumberFormat("pt-BR").format(total)})
                          </span>
                        </div>
                      </Dropdown.Header>
                      {cidades.map((item) => (
                        <Dropdown.Item key={item.companyId} className="p-0">
                          <div
                            // A classe condicional foi movida para este div
                            className={`w-full px-2 py-1.5 ${
                              isCompanySelected(item.companyId)
                                ? "selected-company"
                                : ""
                            }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleCompanySelection(item);
                            }}
                          >
                            <div
                              className="menu-company-list" // A classe condicional foi removida daqui
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              {/* O Checkbox foi removido */}
                              <div className="flex items-center gap-2">
                                <span>{item.companyName}</span>
                              </div>
                              <span>
                                (
                                {new Intl.NumberFormat("pt-BR").format(
                                  item?.statistics?.totalVehicles ?? 0
                                )}
                                )
                              </span>
                            </div>
                          </div>
                        </Dropdown.Item>
                      ))}
                    </Fragment>
                  )
                )}
              </div>
            </Dropdown>
          </div>
          <div className="menu-user-info">
            <Dropdown
              className="dropdown-user-info"
              inline
              label={
                <div>
                  <div className="menu-dropdown">{user.name}</div>
                  <div className="menu-dropdown-icon">
                    <GrDocumentConfig />
                  </div>
                </div>
              }
            >
              <div className="user-info">
                <Dropdown.Header>
                  <div>{user.name}</div>
                  <div>{user.email}</div>
                </Dropdown.Header>
              </div>
              <Dropdown.Item className="pt-0 pb-0">
                <div className="user-config">Minhas configurações</div>
              </Dropdown.Item>
              <Dropdown.Item className="pt-0 pb-0" onClick={() => logout()}>
                <div className="user-config">Sair</div>
              </Dropdown.Item>
            </Dropdown>
          </div>
        </div>
        <div className="espacamento"></div>
      </nav>
    </header>
  );
}

export default TopMenu;
